export const contactHeaderBgImage = require('assets/images/contact-us/contactHeaderBg.webp');
export const businessManagerImage = require('assets/images/contact-us/businessManager.webp');
